import { inject } from "fw";
import { Store, handle } from "fw-state";

import { once, resetAllOnce } from "helpers/once";

import { LogoutAction, StartAction } from "./actions";
import { CasOrganizationIntegrationRepository, ICasOrganizationIntegrationEnvironment } from "network/cas-organization-integration-repository";

interface IAtsOrganizationIntegrationsShape {
    loaded: boolean;
    environments: ICasOrganizationIntegrationEnvironment[];
}

export class AtsOrganizationIntegrationsBustCacheAction {}
export class AtsOrganizationIntegrationsEnsureAction {}

@inject
export class AtsOrganizationIntegrationsStore extends Store<IAtsOrganizationIntegrationsShape> {
    constructor(private casOrgIntegrationRepo: CasOrganizationIntegrationRepository) {
        super();
    }

    defaultState() {
        return {
            loaded: false,
            environments: []
        };
    }

    @handle(StartAction)
    @handle(LogoutAction)
    private handleDefaultActions() {
        this.setState(() => this.defaultState());
    }

    @handle(AtsOrganizationIntegrationsBustCacheAction)
    private async handleBustCacheAction() {
        this.setState(() => this.defaultState());
        resetAllOnce();
        await this.handleEnsureAction();
    }

    @handle(AtsOrganizationIntegrationsEnsureAction)
    private async handleEnsureAction() {
        await once("ensure-ats-organization-integrations", async () => {
            if (this.state.loaded) return;
            this.update();
        });
    }

    private async update() {
        if (this.state.loaded) return;

        const environments = await this.casOrgIntegrationRepo.listEnvironments();

        this.setState((state) => ({
            ...state,
            loaded: true,
            environments
        }));
    }
}
